
import ShoppingCart from '../mixins/shopping-cart'

export default {
  mixins: [ShoppingCart],
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    variantId: {
      type: [Number, String],
      default: null
    },
    input: {
      type: Object,
      default: null
    },
    button: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      quantity: 1
    }
  },
  computed: {
    inputAttrs() {
      return {
        ...this.input,
        disabled: this.disabledForm,
        max: this.max
      }
    },
    buttonAttrs() {
      return {
        ...this.button,
        disabled: this.disabledForm
      }
    },
    disabledForm() {
      return this.disabled || this.max < 1
    },
    inputWidth() {
      return this.input && this.input.width || '2xl'
    },
    max() {
      return Object(this.product).backorderable
        ? Infinity
        : this.availableStock(this.product, this.variantId)
    }
  },
  methods: {
    onChange(value) {
      this.quantity = value
    },
    reset() {
      this.quantity = 1
    },
    onAddToCart() {
      this.reset()
    }
  }
}
